import { trimEnd } from 'lodash'

/**
 * Returns a safe filename by stripping spaces, whitespace, non-ASCII,
 * unprintable, and shell-unsafe characters, preserving the extension.
 *
 * 'Some Thing -something.txt' → 'SomeThing-something.txt'
 */
export function sanitizeFilename(filename) {
    if (!filename) return ''

    const lastDot = filename.lastIndexOf('.')
    const hasExt = lastDot > 0
    const name = hasExt ? filename.slice(0, lastDot) : filename
    const ext = hasExt ? filename.slice(lastDot) : ''

    const sanitizePart = (part) =>
        part
            // Strip non-ASCII and non-printable characters
            .replace(/[^\x20-\x7E]/g, '')
            // Remove whitespace
            .replace(/\s+/g, '')
            // Remove characters unsafe in filenames: / \ : * ? " < > | ; & $ # ! % ^ ~ ` { } [ ] ( ) , '
            .replace(/[/\\:*?"<>|;&$#!%^~`{}[\](),'+]/g, '')
            // Collapse multiple consecutive dashes/underscores/dots to one
            .replace(/[-_.]{2,}/g, (m) => m[0])

    const safeName = trimEnd(sanitizePart(name), '-_.')
    const safeExt = sanitizePart(ext.slice(1))

    return safeExt ? `${safeName}.${safeExt}` : safeName
}
